import { Result } from 'antd';
import moment from 'moment';

const Maintenance = ({ config }) => {
  const formatDateTime = (dateTime) => {
    if (!dateTime) return 'further notice';
    return moment(dateTime).format('DD MMM YYYY, hh:mm A');
  };

  const maintenanceFromTime = config?.maintenanceFromTime ? formatDateTime(config.maintenanceFromTime) : 'now';
  const maintenanceToTime = config?.maintenanceToTime ? formatDateTime(config.maintenanceToTime) : 'further notice';

  const message =
    config?.maintenanceFromTime && config?.maintenanceToTime
      ? `Lumos is in maintenance from ${maintenanceFromTime} till ${maintenanceToTime}.`
      : `Lumos is in maintenance till ${maintenanceToTime}.`;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5'
      }}>
      <Result status="warning" subTitle={message} title="System Maintenance" />
    </div>
  );
};

export default Maintenance;
